import { call, put, takeLatest } from "redux-saga/effects";
import { searchExercisesApi } from "../../../api/exercises";
import { IBaseResponse } from "../../../interfaces/base";
import { IFetchExercisesAction } from "../../../interfaces/store/exercises-interface";
import {
  fetchExercisesSuccess,
  fetchExercisesFailed,
  fetchExercisesStart,
} from "./exercises-slice";

function* _fetchExercises({ payload }: IFetchExercisesAction) {
  try {
    const { sort, filter, pagination, search } = payload;

    const response: IBaseResponse = yield call(searchExercisesApi, {
      sort: sort || { sortBy: "updatedAt", sortOrder: -1 },
      search,
      filter,
      pagination,
    });

    if (response.error) {
      yield put(fetchExercisesFailed(response.error));
    } else {
      yield put(fetchExercisesSuccess({ data: response.data }));
    }
  } catch (error: any) {
    console.log("error:", error);
    yield put(fetchExercisesFailed({ message: error.message }));
  }
}

function* exercisesSaga() {
  yield takeLatest(fetchExercisesStart.type, _fetchExercises);
}

export default exercisesSaga;
